import { Button, Layout, notification, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Sider from "antd/lib/layout/Sider";
import NavMenu, { MenuItem } from "../common/components/NavMenu";
import { useNavigate } from "react-router-dom";
import BrandBarDashboard from "../common/components/BrandBarDashboard";
import UsuariosContext from "../common/contexts/UsuariosContext";
import { MenuUnfoldOutlined } from "@ant-design/icons";

interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
  maxContentWidth?: number;
}

// Estilos
const StyledLayout = styled(Layout)`
  height: 100%;
`;

const StyledBody = styled(Layout)`
  margin-left: 250px;
  width: calc(100% - 250px);
`;

const StyledContent = styled.div`
  padding: 2rem;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 4rem;
`;

const StyledSider = styled(Sider)`
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #212121;
  overflow-x: hidden;
  transition: 0.5s;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  background: var(--primary-color);
  justify-content: center;
  position: sticky;
  top: 0;
  padding: 0.4rem;
  img {
    width: auto;
  }
`;

const DashboardLayout = (props: DashboardLayoutProps) => {
    const navigate = useNavigate();
    const context = useContext(UsuariosContext);
    const [ click, setClick ] = useState<boolean>(true);
    const menuItems: MenuItem[] = [
        {
          title: "Dashboard",
          selectedPath: "/dashboard*",
          key: "dashboard",
          onClick: () => navigate("/dashboard"),
          permissions: ["Graficas.VerGraficas"],
        },        
      ];
      useEffect(() => {
        const isTokenValid = context.checkAuth();
        if (!isTokenValid) {
            notification.info({
                message: 'Su sesion ha expirado (30 dias). Por favor, inicie sesion nuevamente...',
                duration: 5,
                placement: 'bottomRight'
            })
            setTimeout(() => context.signOut(),5000);
        }
    }, []);    
    const handle = () => {
      setClick(!click);
    };    
    return(
        <StyledLayout >
              <StyledSider style = {{ width: click ? "250px" : "0", transform: click ? "translateX(-250px)" : "" }}>
                <TitleContainer >
                  <BrandBarDashboard click = { click } setClick = { setClick } />
                </TitleContainer>                
                <NavMenu showBrandBar = { false } items = { menuItems }/>
              </StyledSider>              
              <StyledBody style = {{ marginLeft: click ? "0" : "250px", width: click ? "100%" : "calc(100% - 250px)" }}>
              <Button type = "primary" onClick = { handle } style = {{ position: "absolute", zIndex: "1",  top: "0",  left: "0", transitionDelay: "750ms", transitionProperty: "margin-left" }}>
              { click ? <MenuUnfoldOutlined /> : undefined }
              </Button>
                <StyledContent>
                  { props.title && (
                    <Typography.Title level = { 4 }>{ props.title }</Typography.Title>
                  ) }
                  { props.children }                  
                </StyledContent>
              </StyledBody>
        </StyledLayout>
    )
};

export default DashboardLayout;